module.exports = __webpack_public_path__ + "04c922d4003deff0984c62b9ca89a294.png";